import { render, staticRenderFns } from "./CuponUsers.vue?vue&type=template&id=c85e5ab6&"
import script from "./CuponUsers.vue?vue&type=script&lang=js&"
export * from "./CuponUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CuponUsers.vue"
export default component.exports